<template>
<section id="contact_form">
  <div class="content_wrap" id="inputForm" v-if="this.step==1">
    <div class="contact_infomation">
      <h2>お問い合わせは以下の内容にそってフォームにご記入ください</h2>
      <ul class="caution">
          <li>フォームにご記入いただいた個人情報は、お問合せへの返答や調査のために利用し、それ以外の目的で利用することは一切ございません。その他、個人情報の取り扱いについてはプライバシーポリシーをお読みください。</li>
          <li>ご返答は、必要な場合に限って5〜10日以内でさせて頂きます。（内容の種類、内容によってはご返答しない場合がございます。予めご了承ください。）</li>
      </ul>
      <dl class="infomation">
          <dt>サイトのご意見ご感想</dt>
          <dd>より良いサイト造りのためにご意見・ご感想をお聞かせください。</dd>
          <dt>プレゼントキャンペーンについて</dt>
          <dd>当選確認に関するお問い合わせはご遠慮ください。</dd>
          <dt>サイトのコンテンツに関して</dt>
          <dd>画像が表示されない、リンク先が無いなど、コンテンツに関して何かございましたら、該当ページのURL、お使いのPC環境（OS、ブラウザの種類）、具体的な内容をお知らせください。</dd>
          <dt>サイトへの広告掲載について</dt>
          <dd>広告掲載を希望されるサロン、スクール経営やメーカー、ディーラーの方に限ります。</dd>
          <dt>その他</dt>
          <dd>上記以外。</dd>
      </dl>
    </div>
    <div id="contactForm">
      <h2>お問い合わせフォーム</h2>
      <form name="form" id="search_form" class="form_wrap" @submit.prevent="confirmationBtn">
        <!--dl class="form_clm required">
          <dt>メールアドレスの種別</dt>
          <dd>
            <p class="form_info">※選択してください</p>
            <ul class="radio_wrap">
                <li>
                  <input type="radio" name="mailType" id="mailType_1" value="PC" v-model="form.mailType" @change="$v.form.mailType.$touch">
                  <label for="mailType_1" id="mailType_type_1" class="radio" >PC</label>
              　</li>
                <li>
                  <input type="radio" name="mailType" id="mailType_2" value="携帯" v-model="form.mailType" @change="$v.form.mailType.$touch">
                  <label for="mailType_2" id="mailType_type_2" class="radio">携帯</label>
              　</li>
            </ul>
            <div v-if="$v.form.mailType.$error">
              <small class="form_error" v-if="!$v.form.mailType.required">{{ errorMessage.mailType }}</small>
            </div>
          </dd>
        </dl><!- - /.form_clm -->
        <dl class="form_clm required">
          <dt>メールアドレス</dt>
          <dd> 
            <label><input class="input" v-model="form.email" @input="$v.form.email.$touch()" type="email" id="mail" name="mail" autocomplete="email" placeholder="info@nail.jp"></label>
            <div v-if="$v.form.email.$error">
              <small class="form_error" v-if="!$v.form.email.required">{{ errorMessage.email }}</small>
              <small class="form_error" v-if="!$v.form.email.email">{{ errorMessage.email2 }}</small>
            </div>
          </dd>
        </dl><!-- /.form_clm -->
        <dl class="form_clm required">
          <dt>お問い合わせの種類</dt>
          <dd>
            <label class="select_wrap">
              <select class="select" id="contact_type" name="contact_type" v-model="form.contactType">
                <option value="サイトのご意見ご感想">サイトのご意見ご感想</option>
                <option value="プレゼントキャンペーンについて">プレゼントキャンペーンについて</option>
                <option value="サイトのコンテンツに関して">サイトのコンテンツに関して</option>
                <option value="サイトへの広告掲載について">サイトへの広告掲載について</option>
                <option value="その他">その他</option>
              </select>
              <i class="material-icons">keyboard_arrow_down</i>
            </label>
          </dd>
        </dl><!-- /.form_clm -->
        <dl class="form_clm required">
          <dt>お問い合わせ内容</dt>
          <dd>
            <textarea id="request" name="request" v-model="form.request" @input="$v.form.request.$touch()"></textarea>
            <small class="form_error" v-if="$v.form.request.error">{{ errorMessage.request }}</small>
            <div v-if="$v.form.request.$error">
              <small class="form_error" v-if="!$v.form.request.required">{{ errorMessage.request }}</small>
              <small class="form_error" v-if="!$v.form.request.minLength">{{ errorMessage.request2 }}</small>
            </div>
          </dd>
        </dl><!-- /.form_clm -->
        <div class="form_clm">
          <button class="btn">送信内容を確認<i class="material-icons">keyboard_arrow_right</i></button>
        </div><!-- /.form_clm -->
      </form>
    </div><!-- /#contactForm -->
  </div><!-- /.content_wrap -->
  <div class="content_wrap" id="confirmationForm" v-if="this.step==2">
    <h2>送信内容の確認</h2>
    <dl class="form_clm required">
      <dt>メールアドレス</dt>
      <dd>{{ this.form.email }}</dd>
    </dl>
    <dl class="form_clm required">
      <dt>お問い合わせの種類</dt>
      <dd>{{ this.form.contactType }}</dd>
    </dl>
    <dl class="form_clm required">
      <dt>お問い合わせ内容</dt>
      <dd class="whiteSpace">{{ this.form.request }}</dd>
    </dl>
    <ul class="btnFlex">
      <li><button class="btn back" @click="backBtn"><i class="material-icons">keyboard_arrow_left</i>戻る</button></li>
      <li><button class="btn" @click="submitForm" v-bind:disabled="isPush">送信する<i class="material-icons">keyboard_arrow_right</i></button></li>
    </ul>
  </div><!-- /.content_wrap -->
  <div class="content_wrap" id="completeForm" v-if="this.step==3">
    <h2>お問い合わせは完了しました</h2>
    <p class="whiteSpace">{{ this.sendedMessage }}</p>
  </div><!-- /.content_wrap -->
</section><!-- /.search_box -->
</template>

<script>
//必須、メールのバリデーションを読み込み
import { required, email,minLength } from 'vuelidate/lib/validators'

export default {
  data () {
    return {
      step:1,
      form: {
        //mailtype:'',
        email: '',
        contactType:'サイトのご意見ご感想',
        request: ''
      },
      errorMessage: {
        //mailType:'選択されていません',
        email:'メールアドレスを入力してください',
        email2:'メールアドレスの形式が正しくありません',
        request:'お問い合わせ内容を入力してください',
        request2:'文字数が少なすぎます、10文字以上入力してください'
      },
      isPush: false,
      sendedMessage: 'この度はお問い合わせいただき、ありがとうございました。\nご返信が必要なお問い合わせについては、改めて担当者よりご連絡いたします。\n万が一、数週間経っても返答がない場合は、改めてフォームよりご連絡くださいませ。'
    }
  },
  validations: {
    form: {
      /*mailType: {
        required
      },*/
      email: {
        required,
        email
      },
      request: {
        required,
        minLength: minLength(10)
      }
    }
  },
  methods: {
    //確認画面へ
    confirmationBtn(){
      this.$v.$touch();
      if(this.$v.$invalid){
        return false;
      }else{
        this.step = 2;
        this.$scrollTo('#contact_title', 300)
      }
    },
    //フォームに戻る
    backBtn(){
      this.step = 1;
      //スクロール処理はupdatedに移動
    },
    //送信
    submitForm() {
      this.isPush = true;
      // POST処理
      const params = {
        email: this.form.email,
        contact_type: this.form.contactType,
        body: this.form.request,
      };
      axios
        .post("/api/contact/send", params)
        // 成功時処理
        .then(res => {
          this.step = 3;
          this.$scrollTo('#contact_title', 300)
        })
        // エラーレスポンス時処理
        .catch(error => {
          console.log(error);
          // 送信エラーをアラート表示
          this.sendedMessage = '申し訳ございません。\n何らかの理由でメールを送信することができませんでした。\nしばらく経ってから再度お試しください。';
          this.step = 3;
        });
    }
  },
  updated :function(){
    //DOMが更新されてからスクロール
    if(this.step == 1) {
      this.$scrollTo('#contactForm', 400,{offset:-40})
    }
  }
}
</script>